import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { CartRulesEntity } from '@models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartRulesApiService extends BaseApi<CartRulesEntity> {
  constructor() {
    super('/AdminPanel/CartRules');
  }

  override get(): Observable<CartRulesEntity> {
    return http$.get<CartRulesEntity>('/AdminPanel/GetCartRules');
  }

  set(model: CartRulesEntity) {
    return http$.put('/AdminPanel/SetCartRules', { rules: model });
  }
}
